import { PengajuanJenisPelatihanRepositoryInterface } from '../../../data/contracts/PengajuanJenisPelatihan';
import { PengajuanJenisPelatihanDataMapper } from '../../../data/mappers/PengajuanJenisPelatihan';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { PengajuanJenisPelatihan } from '../../../entities/PengajuanJenisPelatihan';

export class PengajuanJenisPelatihanApiRepository
  implements PengajuanJenisPelatihanRepositoryInterface
{
  private apiService: ApiService;
  private mapper: PengajuanJenisPelatihanDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: PengajuanJenisPelatihanDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllPengajuanJenisPelatihan(
    page: number,
    rows: number,
    keyword: string,
    sub_menu_jenis_pelatihan_id: string,
    status_pengajuan: string
  ): Promise<PengajuanJenisPelatihan[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.pengajuanJenisPelatihan(),
      {
        page: page,
        rows: rows,
        keyword: keyword,
        sub_menu_jenis_pelatihan_id: sub_menu_jenis_pelatihan_id,
        status_pengajuan: status_pengajuan,
      },
      null,
      headers
    );
    return this.mapper.convertPengajuanJenisPelatihanDataFromApi(dataResponse);
  }

  public async getDetailPengajuanJenisPelatihan(
    id: number
  ): Promise<PengajuanJenisPelatihan> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.pengajuanJenisPelatihan() + '/' + id,
      {},
      null,
      headers
    );
    return this.mapper.convertDetailPengajuanJenisPelatihanDataFromApi(
      dataResponse
    );
  }

  public async storePengajuanJenisPelatihan(
    sub_menu_jenis_pelatihan_id: number,
    nama_pelatihan: string,
    waktu_mulai: string,
    waktu_selesai: string,
    kompetensi: string,
    jp: string,
    keterangan: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    headers.set('Content-Type', 'multipart/form-data');
    let formData = new FormData();
    formData.append(
      'sub_menu_jenis_pelatihan_id',
      sub_menu_jenis_pelatihan_id.toString()
    );
    formData.append('nama_pelatihan', nama_pelatihan);
    formData.append('waktu_mulai', waktu_mulai);
    formData.append('waktu_selesai', waktu_selesai);
    formData.append('kompetensi', kompetensi);
    formData.append('jp', jp);
    formData.append('keterangan', keterangan);
    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.pengajuanJenisPelatihan(),
      null,
      formData,
      headers
    );
    return dataResponse;
  }

  public async updatePengajuanJenisPelatihan(
    id: number,
    sub_menu_jenis_pelatihan_id: number,
    nama_pelatihan: string,
    waktu_mulai: string,
    waktu_selesai: string,
    kompetensi: string,
    jp: string,
    keterangan: string,
    status_pengajuan: string,
    kode: string,
    alasan: string
  ): Promise<any> {
    const params = Object.fromEntries(
      Object.entries({
        sub_menu_jenis_pelatihan_id: sub_menu_jenis_pelatihan_id?.toString(),
        nama_pelatihan,
        waktu_mulai,
        waktu_selesai,
        kompetensi,
        jp,
        keterangan,
        status_pengajuan,
        kode,
        alasan,
      }).filter(([_, v]) => v)
    );

    const queryParams = new URLSearchParams(params).toString();
    const url = `${this.endpoints.pengajuanJenisPelatihan()}/${id}${
      queryParams ? `?${queryParams}` : ''
    }`;
    const dataResponse = await this.apiService.invoke('put', url);
    return dataResponse;
  }

  public async deletePengajuanJenisPelatihan(id: number): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'delete',
      this.endpoints.pengajuanJenisPelatihan() + '/' + id,
      {},
      null,
      headers
    );
    return dataResponse;
  }
}
